import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux';
import { getTranslation } from '../actions/dataActions'
import { toggleKeyboard } from '../actions/layoutActions'
import * as resource from '../constants/Resources'
import Ink from 'react-ink'
import PropTypes from 'prop-types'
import { barcodeScanned } from '../actions/barcodeActions';

const ScanReservation = props => {
  const {
    barcodeScanned,
    toggleKeyboard,
    getTranslation,
    input
  } = props;

  const [useManualInput, setUseManualInput] = useState(false);
  const [lastEnteredBarcode, setLastEnteredBarcode]= useState('');

  useEffect(() => {
    setLastEnteredBarcode(input);
  });

  const fetchReservation = number => {
    if (number && number !== '') {
      barcodeScanned(number);
    }
  }

  const handleClick = () => {
    fetchReservation(input);
  }

  const showKeyboard = () => {
    toggleKeyboard(true, null, 'Reserveringsnummer', fetchReservation, [], false, lastEnteredBarcode);
    setUseManualInput(true);
  }

  const hideKeyboard = () => {
    setUseManualInput(false);
  }

  return (
    <div className="reservation-scanner-component">
      {!useManualInput &&
        <div className="scan-reservation-message">{getTranslation(resource.SCAN_RESERVATION)}</div>
      }
      {useManualInput &&
        <div className="manual-input">
          <input
            id="reservationcode"
            className="reservation"
            type="text"
            placeholder="Reservering"
            onClick={showKeyboard}
            value={input}
            readOnly={true}
          />
          <button type="button" className="scanbutton" onClick={handleClick}>
            {getTranslation(resource.COLLECT_RESERVATION)}
            <Ink />
          </button>
        </div>
      }
      <div className="action-buttons">
        <div className="action-buttons-spacer"></div>
        {!useManualInput &&
          <div className="action-button" onClick={showKeyboard}>
            <i className="large keyboard icon" />
            <Ink />
          </div>
        }
        {useManualInput &&
          <div className="action-button" onClick={hideKeyboard}>
            <i className="large qrcode icon" />
            <Ink />
          </div>
        }
      </div>
    </div>
  )
}

ScanReservation.propTypes = {
  toggleKeyboard: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  input: state.layoutState.keyboard.input
})

export default connect(mapStateToProps, {
  getTranslation,
  toggleKeyboard,
  barcodeScanned
})(ScanReservation)



// WEBPACK FOOTER //
// src/components/ScanReservation.jsx